// extracted by mini-css-extract-plugin
export default {"newselection":"BasicSelect_newselection__OHqol"};